import React__default, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import '../../../rev/layouts/Alignment/alignment.scss';
import '../../../rev/layouts/Box.js';
import { Group } from '../../../rev/layouts/Group.js';
import '../../../rev/layouts/Section.js';
import '../../../rev/layouts/Spacing/spacing.scss';
import { Stack } from '../../../rev/layouts/Stack.js';
import '../../../rev/atoms/Badge.scss';
import 'react-aria-components';
import '../../../rev/atoms/Breadcrumbs.scss';
import { Button } from '../../../rev/atoms/Button.js';
import { Callout } from '../../../rev/atoms/Callout.js';
import '../../../rev/atoms/Card.scss';
import '../../../rev/atoms/Checkbox.js';
import 'lodash';
import '../../../rev/atoms/CheckboxGroup.scss';
import '../../../rev/atoms/Tag.scss';
import '../../../rev/atoms/Chip.scss';
import '../../../rev/atoms/DateInput.js';
import '../../../rev/atoms/Text.js';
import '../../../rev/atoms/Divider.scss';
import '../../../rev/atoms/Spinner.scss';
import '../../../rev/atoms/Dropzone.scss';
import '../../../rev/atoms/Empty.scss';
import 'motion/react';
import '../../../rev/molecules/RichDescription.js';
import '../../../rev/molecules/TitleGroup.scss';
import '../../../rev/atoms/EmptySearchResults.scss';
import 'classnames';
import '../../../rev/atoms/Image.scss';
import '@mui/icons-material/EmailOutlined';
import '@mui/icons-material/PhoneOutlined';
import '@mui/icons-material/PlaceOutlined';
import '@mui/icons-material/ScheduleOutlined';
import '../../../rev/atoms/LabelledList.scss';
import '../../../rev/atoms/LabelPrice.scss';
import '../../../rev/atoms/Link.scss';
import '../../../rev/atoms/ListViewGroup.scss';
import '../../../rev/atoms/ListViewRow.scss';
import '../../../rev/atoms/Note.scss';
import '../../../rev/atoms/OldTextInput.js';
import '../../../rev/atoms/RadioGroup.scss';
import 'framer-motion';
import '../../../rev/atoms/SegmentedControl.scss';
import '../../../rev/atoms/Skeleton.scss';
import '@mui/icons-material/InfoOutline';
import '../../../rev/molecules/Tooltip/Tooltip.js';
import '../../../rev/atoms/Slider.scss';
import '../../../rev/atoms/SteppedProgressBar.scss';
import '../../../rev/atoms/Switch.js';
import '../../../rev/atoms/Tabs.scss';
import '../../../rev/atoms/TextArea.js';
import { TextInput } from '../../../rev/atoms/TextInput.js';
import '../../../rev/atoms/TimeInput.js';
import '../../../rev/atoms/ToggleButton.js';
import '../../../rev/atoms/ToggleGroup.js';
import 'react-dom';
import '../../../rev/molecules/EmbeddedVideoPlayer/EmbeddedVideoPlayer.scss';
import '../../../rev/molecules/Accordion.scss';
import '../../../rev/molecules/ActionMenu.scss';
import '../../../rev/molecules/BankInfo/BankInfo.scss';
import '../../../rev/molecules/Carousel.scss';
import '../../../rev/molecules/ContentSlider.js';
import '../../../rev/molecules/Drawer.js';
import '../../../rev/molecules/Dropdown.scss';
import '../../../rev/molecules/Form/index.js';
import '@dnd-kit/core';
import '../../../rev/molecules/Kanban/KanbanBoard.scss';
import '../../../rev/molecules/Lightbox.scss';
import 'jotai';
import '../../../components/loadingAtoms.js';
import '../../../rev/molecules/LoadingPage.scss';
import '../../../rev/molecules/NavigationMenu.scss';
import '@mui/icons-material/Search';
import 'react-aria';
import 'react-stately';
import 'smartystreets-javascript-sdk';
import 'smartystreets-javascript-sdk-utils';
import '../../../utils/addressCache.js';
import '../../../rev/molecules/OldAddressInput.scss';
import '../../../rev/atoms/Button.scss';
import '../../../rev/molecules/OrderFooter.scss';
import '../../../rev/molecules/Pagination.scss';
import '../../../rev/molecules/Popover.js';
import { PopupTrigger, Popup } from '../../../rev/molecules/Popup.js';
import '../../../rev/molecules/SearchInput.scss';
import '../../../rev/molecules/Sheet.js';
import '../../../rev/molecules/Table/Table.scss';
import '../../../rev/molecules/Toast.js';
import '../../../rev/molecules/ToggleCard/ToggleCard.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardDescriptionBlock.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardGroup.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardHeader.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardRadioContent.scss';
import '@react-aria/utils';
import '../../../rev/molecules/TopBar.scss';
import '@mui/icons-material/Check';
import '../../../rev/organisms/ach/ConnectBankAccount.scss';
import '../../../rev/organisms/ach/ConnectedBankInfo.scss';
import '../../../rev/organisms/AddressInput.js';
import { useHorizontalSizeClass } from '../../../rev/hooks/useSizeClass.js';
import '../../../rev/sections/CalculatePaymentModal.scss';
import '../../../rev/sections/ConfirmAddressModal.scss';
import '../../../rev/sections/CoverageMenuSection/CoverageItemAssurance.scss';
import '../../../rev/sections/CoverageMenuSection/CoverageItemProductSummary.js';
import '../../../rev/sections/CoverageMenuSection/CoverageMenuSection.scss';
import '../../../rev/sections/CoverageMenuSection/fixtures/coverageMenuFixtureData.js';
import '../../../rev/sections/FormModal/schemas.js';
import '@hookform/resolvers/zod';
import '@internationalized/date';
import '../../../constants.js';
import '../../../rev/sections/FormModal/FormModal.scss';
import '../../../rev/sections/FormModal/types.js';
import 'moment';
import '../../../types/leads/Lead.js';
import '../../../rev/sections/LeadsSection/LeadCard.scss';
import { useAuthContext } from '../../providers/AuthContext.js';
import { getLoginErrorMessage } from '../../utils/authErrorMessages.js';
import { EyeIcon, EyeOffIcon } from '../common/AuthIcons.js';

/**
 * Re-authentication popup for when Firebase requires a recent login.
 * Shows a password-only form since we already know the user's email.
 * Uses reauthenticateWithCredential to refresh the current user's credentials
 * without creating a new session or triggering global loading state.
 */
function ReauthPopup({ isOpen, onOpenChange, onSuccess, onForgotPassword, }) {
    const { authService } = useAuthContext();
    const [error, setError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const horizontalSizeClass = useHorizontalSizeClass();
    const isMobile = horizontalSizeClass === 'compact';
    const { control, handleSubmit, reset, formState: { errors, isSubmitting, isValid }, } = useForm({
        mode: 'onChange',
        defaultValues: {
            password: '',
        },
    });
    const handleClose = () => {
        setError(null);
        reset();
        onOpenChange(false);
    };
    const onSubmit = handleSubmit(async (data) => {
        setError(null);
        setIsLoading(true);
        try {
            // Use reauthenticate to refresh the current user's credentials
            // This is required for sensitive operations like MFA enrollment
            await authService.reauthenticate(data.password);
            // Success - close popup and trigger retry
            reset();
            onOpenChange(false);
            onSuccess();
        }
        catch (err) {
            const authError = err;
            setError(getLoginErrorMessage(authError.code ?? 'auth/unknown-error'));
        }
        finally {
            setIsLoading(false);
        }
    });
    const isButtonDisabled = !isValid || isLoading || isSubmitting;
    return (React__default.createElement(PopupTrigger, { isOpen: isOpen, onOpenChange: onOpenChange },
        React__default.createElement(Popup, { title: 'Confirm password', description: 'For security reasons, please confirm your password to continue setting up your account.', hasCloseButton: true, size: isMobile ? 'fullscreen' : 'small' }, (closePopup) => (React__default.createElement("form", { onSubmit: onSubmit },
            React__default.createElement(Stack, { itemsSpacing: '24' },
                React__default.createElement(Controller, { name: 'password', control: control, rules: {
                        required: 'Password is required',
                    }, render: ({ field: { onChange, onBlur, value } }) => (React__default.createElement(TextInput, { label: 'Password', type: showPassword ? 'text' : 'password', value: value, onChange: onChange, onBlur: onBlur, placeholder: '', name: 'password', ariaLabel: 'Password', hasError: errors.password?.message, isDisabled: isLoading || isSubmitting, rightContent: React__default.createElement("button", { type: 'button', className: 'auth-password-toggle', onClick: () => setShowPassword(!showPassword), "aria-label": showPassword ? 'Hide password' : 'Show password' }, showPassword ? React__default.createElement(EyeIcon, null) : React__default.createElement(EyeOffIcon, null)) })) }),
                onForgotPassword && (React__default.createElement(Group, { itemsAlignX: 'start' },
                    React__default.createElement(Button, { variant: 'underlined', onPress: onForgotPassword }, "Forgot password?"))),
                error && React__default.createElement(Callout, { variant: 'error', message: error }),
                isMobile ? (React__default.createElement(Button, { variant: 'filled', size: 'large', type: 'submit', isFullWidth: true, isLoading: isLoading || isSubmitting, isDisabled: isButtonDisabled, onPress: () => onSubmit() }, "Continue")) : (React__default.createElement(Group, { itemsSpacing: '16', itemsAlignX: 'end', noWrap: true },
                    React__default.createElement(Button, { variant: 'secondary', size: 'large', isDisabled: isLoading || isSubmitting, onPress: () => {
                            handleClose();
                            closePopup();
                        } }, "Cancel"),
                    React__default.createElement(Button, { variant: 'filled', size: 'large', type: 'submit', isLoading: isLoading || isSubmitting, isDisabled: isButtonDisabled, onPress: () => onSubmit() }, "Continue")))))))));
}

export { ReauthPopup };
//# sourceMappingURL=ReauthPopup.js.map
